export const line_height_1_25 = 1.25
export const line_height_1_5 = 1.5
export const letter_spacing_1 = 1
